const STORAGE_KEY = 'webpos:station_id';
const TERMINAL_ID_KEY = 'webpos:terminal_id';

export const getStationId = (): string | null => {
    try {
        return localStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
};

export const setStationId = (stationId: string): void => {
    try {
        localStorage.setItem(STORAGE_KEY, stationId);
    } catch {
        // Ignore storage errors (private browsing, storage disabled, etc.)
    }
};

export const clearStationId = (): void => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // Ignore storage errors
    }
};

const generateId = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    // Fallback for browsers without crypto.randomUUID
    return `terminal-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

/**
 * A stable id for this specific browser/terminal, independent of which
 * station it's assigned to. Used to hard-lock a pos_station row to one
 * terminal (see /signon/stations/{id}/claim) so two terminals can never be
 * provisioned onto the same station.
 */
export const ensureTerminalId = (): string => {
    try {
        const existing = localStorage.getItem(TERMINAL_ID_KEY);
        if (existing) {
            return existing;
        }
        const generated = generateId();
        localStorage.setItem(TERMINAL_ID_KEY, generated);
        return generated;
    } catch {
        return generateId();
    }
};
